<template>
    <div
        class="dropdown"
        ref="dropdown"
        :class="rootClasses"
    >
        <div
            v-if="!inline"
            role="button"
            ref="trigger"
            class="dropdown-trigger"
            @click="toggle"
            @mouseover="handle_mouseover"
            @mouseout="handle_mouseout"
            aria-haspopup="true"
        >
            <slot name="trigger" />
        </div>
<!--        <transition :name="animation">-->
            <div
                v-if="isMobileModal"
                v-show="isActive"
                class="background"
                :aria-hidden="!isActive"
            />
<!--        </transition>-->
<!--        <transition :name="animation">-->
            <div
                v-show="is_menu_visible"
                ref="dropdownMenu"
                class="dropdown-menu"
                :aria-hidden="!isActive"
            >
                <div
                    class="dropdown-content"
                    :role="ariaRoleMenu"
                >
                    <slot />
                </div>
            </div>
<!--        </transition>-->
    </div>
</template>
<script>
export default {
    name: 'BDropdown',
    props: {
        value: {
            type: [String, Number, Boolean, Object, Array, Symbol, Function],
            default: null
        },
        disabled: Boolean,
        hoverable: Boolean,
        inline: Boolean,
        position: {
            type: String,
            validator(value) {
                return [
                    'is-top-right',
                    'is-top-left',
                    'is-bottom-left'
                ].indexOf(value) > -1
            }
        },
        mobileModal: {
            type: Boolean,
            default: true
        },
        ariaRole: {
            type: String,
            default: ''
        },
        animation: {
            type: String,
            default: 'fade'
        }
    },
    data() {
        return {
            dropdown_wrapper: null,
            selected: this.value,
            isActive: false,
            _isDropdown: true // Used internally by DropdownItem
        }
    },
    computed: {
        rootClasses() {
            return [this.position, {
                'is-disabled': this.disabled,
                'is-hoverable': this.hoverable,
                'is-inline': this.inline,
                'is-active': this.isActive || this.inline,
                'is-mobile-modal': this.isMobileModal
            }]
        },
        isMobileModal() {
            return this.mobileModal && !this.inline && !this.hoverable
        },
        is_menu_visible() {
            return (!this.disabled && (this.isActive || this.hoverable)) || this.inline
        },
        ariaRoleMenu() {
            return this.ariaRole === 'menu' || this.ariaRole === 'list' ? this.ariaRole : null
        }
    },
    methods: {
        /**
         * Click listener from DropdownItem.
         *   1. Set new selected item.
         *   2. Emit input event to update the user v-model.
         *   3. Close the dropdown.
         */
        selectItem(value) {
            if (this.selected !== value) {
                this.$emit('change', value)
                this.selected = value
            }
            this.$emit('input', value)
            this.isActive = false
        },
        handle_mouseout() {
            if (!this.hoverable || !this.dropdown_wrapper) {
                return
            }
            this.dropdown_wrapper.classList.remove('is-active')
        },
        handle_mouseover() {
            if (!this.hoverable || !this.dropdown_wrapper) {
                return
            }
            this.position_menu()
            this.dropdown_wrapper.classList.add('is-active')
        },
        /**
         * White-listed items to not close when clicked.
         */
        isInWhiteList(el) {
            if (el === this.$refs.dropdownMenu) return true
            if (el === this.$refs.trigger) return true
            // All chidren from dropdown
            if (this.$refs.dropdownMenu !== undefined) {
                const children = this.$refs.dropdownMenu.querySelectorAll('*')
                for (const child of children) {
                    if (el === child) {
                        return true
                    }
                }
            }
            // All children from trigger
            if (this.$refs.trigger !== undefined) {
                const children = this.$refs.trigger.querySelectorAll('*')
                for (const child of children) {
                    if (el === child) {
                        return true
                    }
                }
            }
            return false
        },
        /**
         * Close dropdown if clicked outside.
         */
        clickedOutside(event) {
            if (this.inline) return
            if (!this.isInWhiteList(event.target)) this.isActive = false
        },
        position_menu() {
            const dropdown_menu_ref = this.$refs.dropdownMenu
                , ref = this.$refs.dropdown
            if (!ref || !dropdown_menu_ref) {
                return
            }
            if (this.dropdown_wrapper === null) {
                this.dropdown_wrapper = document.createElement('div')
                this.dropdown_wrapper.onclick = this.toggle
                this.dropdown_wrapper.style.margin = '0px'
                this.dropdown_wrapper.style.position = 'absolute'
                this.dropdown_wrapper.style.zIndex = 2
                this.dropdown_wrapper.appendChild(dropdown_menu_ref)
                document.body.appendChild(this.dropdown_wrapper)
            }
            this.dropdown_wrapper.setAttribute('class', ref.getAttribute('class'))
            const ref_rect = ref.getBoundingClientRect()
            let x = 0, y = 0
            switch (this.position) {
                case 'is-top-right':
                    break
                case 'is-top-left':
                    x = ref_rect.width
                    break
                case 'is-bottom-left':
                    x = ref_rect.width
                    y = ref_rect.height
                    break
                case 'is-bottom-right':
                default:
                    y = ref_rect.height
                    break
            }
            const pos_x = ref_rect.x + window.scrollX + x
                , pos_y = ref_rect.y + window.scrollY + y
            this.dropdown_wrapper.style.left = `${pos_x}px`
            this.dropdown_wrapper.style.top = `${pos_y}px`
        },
        /**
         * Toggle dropdown if it's not disabled.
         */
        toggle() {
            if (this.disabled || this.hoverable) return
            if (!this.isActive) {
                // if not active, toggle after clickOutside event
                // this fixes toggling programmatic
                this.$nextTick(() => { this.isActive = !this.isActive })
            } else {
                this.isActive = !this.isActive
            }
        }
    },
    mounted() {
        this.$nextTick(this.position_menu)
    },
    created() {
        if (typeof window !== 'undefined') {
            document.addEventListener('click', this.clickedOutside)
        }
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            document.removeEventListener('click', this.clickedOutside)
        }
        if (this.dropdown_wrapper) {
            this.dropdown_wrapper.remove()
        }
    },
    watch: {
        /**
         * When v-model is changed set the new selected item.
         */
        value(value) {
            this.selected = value
        },
        /**
         * Emit event when isActive value is changed.
         */
        isActive(value) {
            this.$emit('active-change', value)
            if (this.dropdown_wrapper) {
                this.$nextTick(this.position_menu)
            }
        },
    },
}
</script>
